import {
  useCreditsStore,
  selectCreditsPillVisible,
  selectAvailableCenti,
  selectCreditsPhase,
  formatCredits,
} from '../state/creditsStore';

// ════════════════════════════════════════════════════════════════════════════
// BalancePill — pure renderer of the credits wallet region (F3, Frontend FSM
// pattern element #2: components render machine state, they never own it).
//
// DARK BY DEFAULT: renders NOTHING until the first CREDIT_BALANCE arrives this
// session (selectCreditsPillVisible === false → null). A dogfood user whose tier
// never emits a balance sees zero visual change — no layout, no placeholder.
//
// Firewall-neutral (shared-ui/): mounted once in App.tsx above both shells, so
// its fixed pill renders identically on mobile (390px) and desktop.
// ════════════════════════════════════════════════════════════════════════════

export function BalancePill() {
  const visible = useCreditsStore(selectCreditsPillVisible);
  const availCenti = useCreditsStore(selectAvailableCenti);
  const phase = useCreditsStore(selectCreditsPhase);
  const openTopUpModal = useCreditsStore((s) => s.openTopUpModal);
  // Held (reserved by open holds) — subtle secondary. Read as a primitive so the
  // selector is referentially stable (no per-render object → no render churn).
  const heldCenti = useCreditsStore((s) => {
    const w = s.activeUserId ? s.wallets[s.activeUserId] : undefined;
    return w && w.live ? w.heldCenti : 0;
  });

  if (!visible || availCenti == null) return null;

  const held = heldCenti > 0 ? formatCredits(heldCenti) : null;
  const low = phase === 'low';

  return (
    <button
      type="button"
      class={`balance-pill${low ? ' balance-pill--low' : ''}`}
      onClick={() => openTopUpModal(null)}
      title={low ? 'Low balance — tap to top up' : 'Credits balance — tap to top up'}
      aria-label={`Credits balance ${formatCredits(availCenti)}${held ? `, ${held} held` : ''}. Tap to top up.`}
    >
      <span class="balance-pill__amount">{formatCredits(availCenti)}</span>
      <span class="balance-pill__unit">cr</span>
      {held && <span class="balance-pill__held">({held} held)</span>}
    </button>
  );
}
